import { render } from "./SiteHazardRow.vue?vue&type=template&id=8b4e5254"
import script from "./SiteHazardRow.vue?vue&type=script&lang=js"
export * from "./SiteHazardRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__